import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthService } from 'app/services/auth.service';
import { PageService } from 'app/services/models/page.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-page-list',
  templateUrl: './page-list.component.html',
  styleUrls: ['./page-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;
  constructor(
    private pageService: PageService,
    private _coreSidebarService: CoreSidebarService,
    public authService:AuthService
  ) { }

  async ngOnInit() {
    this.pageService.event$.subscribe(async result => {
      await this.getAllPagesList(this.pageBasic - 1, this.selectedSize)
    })
    await this.getAllPagesList(this.pageBasic - 1, this.selectedSize)
  }

  async getAllPagesList(page, size) {
    const pageAuthorization = this.authService.isEndpointStatus('GET.Reading.GetAllPageList');
    if(pageAuthorization){
      const data = await this.pageService.getAllPagesList(page, size);
      console.log(data);
      this.totalCount = data.totalCount;
      this.rows = data.pages;  
    }
  }

  async onPageChange(pageNumber: number) {
    await this.getAllPagesList(this.pageBasic - 1, this.selectedSize);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllPagesList(this.pageBasic - 1, this.selectedSize);
  }

  editPage(row) {
    console.log(row);
  }

  selectedPage: any;
  toggleSidebar(name, row): void {
    this.selectedPage = row;
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }
}
